import {CsvImportFailedRow} from 'models/CsvImportSummary'

export type ErrorFileRow = {
  Row: number
  Patient: string
  Device: string
  Error: string
}

const buildErrorFileRows = (failedRows: CsvImportFailedRow[]): ErrorFileRow[] =>
  failedRows.map(row => ({
    Row: row.rowNumber,
    Patient: row.patientName ?? '',
    Device: row.deviceSerial ?? '',
    Error: row.message,
  }))

export default buildErrorFileRows
